import axios from '@/api/axios';
import type {
  AdminPaginatedEnvelope,
  AfriexFeature,
  AfriexFeatureStatus,
  AfriexID,
} from '@/types';
const endpoint = '/v2/admin/features';
export const featureService = {
  getFeatureList: async (
    params: {
      page?: number;
      limit?: number;
      status?: AfriexFeatureStatus;
    } = {},
  ): Promise<AdminPaginatedEnvelope<AfriexFeature[]>> => {
    const response = await axios.get<AdminPaginatedEnvelope<AfriexFeature[]>>(
      endpoint,
      {params},
    );
    return response?.data;
  },
  /** Whether a feature is switched on for anyone. */
  getFeatureStatus: async (code: string): Promise<boolean> => {
    const response = await axios.get<{data: {isActive: boolean}}>(
      `${endpoint}/active/${encodeURIComponent(code)}`,
    );
    return Boolean(response?.data?.data?.isActive);
  },
  createFeature: async (item: AfriexFeature): Promise<AfriexFeature> => {
    const response = await axios.post<AfriexFeature>(endpoint, item);
    return response?.data;
  },
  updateFeatureById: async (
    id: AfriexID,
    item: AfriexFeature,
  ): Promise<AfriexFeature> => {
    const url = `${endpoint}/${id}`;
    const response = await axios.patch<AfriexFeature>(url, item);
    return response?.data;
  },
  removeFeatureById: async (id: AfriexID): Promise<AfriexFeature> => {
    const url = `${endpoint}/${id}`;
    const response = await axios.delete<AfriexFeature>(url);
    return response?.data;
  },
};

export type FeatureService = typeof featureService;
